module.exports = __webpack_public_path__ + "static/img/PC-1.6a40e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-1.png
// module id = FMef
// module chunks = 0